import ja from '../translations/ja.json';
export default ja;



// WEBPACK FOOTER //
// ./~/@99designs/globalnav/locale-data/ja.js